/**
 * 置顶横幅纯逻辑（14.10b；组件在 PinBanner.tsx）。
 *
 * 轮播口径：pins 按 msgId 升序（Worker 契约），横幅初始展示**最新一条**
 * （cursor=len-1），点击=跳转当前条并把游标移向更早一条（到头回绕最新）——
 * 对齐旧版「点击轮播下一条」与主流 IM（Telegram）的置顶轮播手感。
 * pins 推送整体替换后游标可能越界，渲染前统一钳制。
 */
import type { PinnedMessage } from '~/worker/contract';
import { messagePreview } from '~/chat/preview';

/** pins 变化后游标钳制：空列表归 0（横幅本就不渲染），越界取最新一条 */
export function clampPinCursor(cursor: number, len: number): number {
  if (len <= 0) return 0;
  return cursor >= 0 && cursor < len ? cursor : len - 1;
}

/** 点击横幅后的下一个游标：向更早一条移动，到头回绕最新（len≤1 恒 0） */
export function advancePinCursor(cursor: number, len: number): number {
  if (len <= 1) return 0;
  const cur = clampPinCursor(cursor, len);
  return cur === 0 ? len - 1 : cur - 1;
}

/**
 * 置顶条目的预览文本（横幅/sheet 共用）：复用会话预览单点 messagePreview
 * （PinnedMessage.msgType=原消息类型、content 与时间线行 msg 同形，14.10a 实锤），
 * 未映射类型兜底 [消息]。
 */
export function pinPreviewText(pin: PinnedMessage): string {
  const text = messagePreview(pin.msgType, pin.content, pin.ext);
  return text !== '' ? text : '[消息]';
}
